
export const columns = [
  {
    Header: 'Characteristic',
    accessor: 'name',
    minWidth: 300,
    maxWidth: 400,
  },
  {
    Header: 'Value',
    accessor: 'value',
  },
];

export default {
  columns,
};



// WEBPACK FOOTER //
// ./src/components/grids/TechInfoGrid/gridConfig.jsx